import {computed, decorate, observable} from 'mobx';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFile, faFileAlt, faFileImage, faFilePdf, faLink} from '@fortawesome/free-solid-svg-icons';
import {BaseModel} from './base';

export const DocumentTypes = Object.freeze({
  file: 'file',
  link: 'link',
});

/**
 * Value is in MB.
 */
export const DOCUMENT_MAX_FILE_SIZE = 20;

export const DocumentAssociations = Object.freeze({
  hierarchyIds: 'hierarchyIds',
  materials: 'materials',
  inspectionTasksIds: 'inspectionTasksIds',
  codes: 'codes',
  changeDocuments: 'changeDocuments',
});

export class Document extends BaseModel {
  static faIcon = faFileAlt;

  searchableProperties = ['filename', 'label'];
  nestedModels = ['hierarchies', 'changeDocuments', 'materials', 'inspectionTasks'];

  static prepareApiPayload(model) {
    return {
      ...model,
      documentTypeId: model.documentTypeId || null,
    };
  }

  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);

    this.hierarchies = this.hierarchyIds
      ?.map((hierarchyId) => rootStore.hierarchyStore.getById(hierarchyId))
      ?.filter((hierarchyId) => hierarchyId)
      || [];

    this.documentType = rootStore.documentTypeStore.getById(this.documentTypeId);
  }

  get isPDF() {
    return this.mimeType && this.mimeType === 'application/pdf';
  }

  get isImage() {
    return this.mimeType && this.mimeType.includes('image/');
  }

  get icon() {
    if (this.isPDF) {
      return <FontAwesomeIcon icon={faFilePdf}/>;
    }
    if (this.isImage) {
      return <FontAwesomeIcon icon={faFileImage}/>;
    }
    if (this.link) {
      return <FontAwesomeIcon icon={faLink}/>;
    }

    return <FontAwesomeIcon icon={faFile}/>;
  }
}

decorate(Document, {
  id: observable,
  filename: observable,
  label: observable,
  link: observable,
  localFilename: observable,
  src: observable,
  hierarchies: observable,
  hierarchyIds: observable,
  inspectionTasks: observable,
  inspectionTasksIds: observable,
  changeDocuments: observable,
  materials: observable,
  externalId: observable,
  version: observable,
  documentTypeId: observable,
  documentType: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
  deletedAt: observable,
  deletedBy: observable,
  expireDate: observable,
  icon: computed,
});
